import React, { useContext, useEffect, useState } from "react";
import { Stores, StoresContext } from "Globals/Stores";
import { PrivateRoute } from "Globals/Views/PrivateRoute";
import * as RouterUtil from "Utils/Routing";
import { StoresInstance } from "Globals/Stores";
import { AppUrls } from "../../../AppUrls";
import { DarwinLayout, DefaultLayout } from "Globals/Views/Layouts";
import { InductionUserMenuView } from "./InductionUserMenuView";
import { InductionUserPermitView } from "./InductionUserPermitView";
import { InductionUserInspectionView } from "./InductionUserInspectionView";
import { ProjectListViewModel } from "../ProjectListViewModel";
import { ProjectListModelWithAddress } from "../ProjectListModelWithAddress";
import { SHBox } from "../../../Components/Box";
import { InductionUserNearMissView } from "./InductionUserNearMissView";
import { InductionUserScaffoldView } from "./InductionUserScaffoldView";

export const InductionUserProjectRoutes: React.FC = () => {
    const [viewModel] = useState(() => new ProjectListViewModel());
    const [projectDetails, setProjectDetails] = useState<ProjectListModelWithAddress>({} as ProjectListModelWithAddress);
    const store = useContext<Stores>(StoresContext);
    function getRootLayout() {
        return DarwinLayout;
    }

    useEffect(() => {
        //PackagesViewModel.Instance.apiGetRelated();
        viewModel.apiGetProjectDetailsByUserId().then((response) => {
            if (response) {
                setProjectDetails(response);
            }
        });
        return () => {};
    }, []);

    return (
        <SHBox id={"inductionUserRootContainer"}>
            <PrivateRoute
                exact
                path={AppUrls.Client.Project.InductionUser.Menu}
                component={() => <InductionUserMenuView viewModel={viewModel} projectDetails={projectDetails} />}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.requireAnyLoggedIn(StoresInstance);
                }}
                layout={getRootLayout()}
            />

            <PrivateRoute
                exact
                path={AppUrls.Client.Project.InductionUser.Permit}
                component={() => <InductionUserPermitView viewModel={viewModel} projectDetails={projectDetails} />}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.requireAnyLoggedIn(StoresInstance);
                }}
                layout={getRootLayout()}
            />

            <PrivateRoute
                exact
                path={AppUrls.Client.Project.InductionUser.Inspection}
                component={() => <InductionUserInspectionView viewModel={viewModel} projectDetails={projectDetails} />}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.requireAnyLoggedIn(StoresInstance);
                }}
                layout={getRootLayout()}
            />

            <PrivateRoute
                exact
                path={AppUrls.Client.Project.InductionUser.NearMiss}
                component={() => <InductionUserNearMissView viewModel={viewModel} projectDetails={projectDetails} />}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.requireAnyLoggedIn(StoresInstance);
                }}
                layout={getRootLayout()}
            />

            <PrivateRoute
                exact
                path={AppUrls.Client.Project.InductionUser.Scaffold}
                component={() => <InductionUserScaffoldView viewModel={viewModel} projectDetails={projectDetails} />}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.requireAnyLoggedIn(StoresInstance);
                }}
                layout={getRootLayout()}
            />
        </SHBox>
    );
};
